var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Info-outline_svg__clip0_53_504)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.849 1.012a.996.996 0 00-.827.78L.027 18.772a1 1 0 001.946.457L5.03 6.241l2.496 9.982.01.042 1.495 5.978a1 1 0 001.94-.485L9.78 17h10.94l1.31 5.243a1 1 0 001.94-.485l-1.495-5.98a.995.995 0 00-.01-.042L18.97 1.758A1 1 0 0018 1H5.022a.996.996 0 00-.173.012zM20.219 15l-3-12H6.281l3 12h10.938z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Info-outline_svg__clip0_53_504"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgInfoOutline;